import React, { Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback2 } from '../../common/models/callback';
import { Column } from '../../common/models/table/Column';
import Checkbox from '../Checkbox';
import Icon from '../Icon';
import styles from './styles.module.scss';

export const dragColumn: Column = {
  disableSortBy: true,
  disableFilters: true,
  defaultCanSort: false,
  defaultCanFilter: false,
  id: 'drag',
  accessor: 'drag',
  width: 120,
  editable: false,
  Header: () => <FormattedMessage id="order" defaultMessage="Order" />,
  Cell: ({ row: { index } }) => (
    <span className="d-flex align-items-center justify-content-start">
      <Icon icon="drag" className={styles.dragIcon} />
      <span className={styles.order}>{index + 1}</span>
    </span>
  )
};

export const getCheckboxColumn = (
  hideCheckboxHeader: boolean,
  rowSelection: 'single' | 'multiple',
  total: number,
  itemsLength: number,
  onLoad: IBindingCallback2<number, number>,
  setPreSelectAll: Dispatch<SetStateAction<boolean>>,
  onRowSelected: IBindingCallback2<any, boolean>
): Column => ({
  disableSortBy: true,
  disableFilters: true,
  defaultCanSort: false,
  defaultCanFilter: false,
  id: 'selection',
  accessor: 'selection',
  width: 56,
  editable: false,
  Header: ({ getToggleAllRowsSelectedProps, toggleAllRowsSelected }) => (
    !hideCheckboxHeader && rowSelection === 'multiple'
      ? (
        <Checkbox {...{
          ...getToggleAllRowsSelectedProps(),
          onChange: e => {
            const { target: { checked } } = e;
            if (checked && total !== itemsLength) {
              onLoad(0, 0);
              setPreSelectAll(true);
            } else {
              toggleAllRowsSelected(checked);
            }
          }
        }}
        />
      )
      : null
  ),
  Cell: ({ row, toggleRowSelected, toggleAllRowsSelected }) => (
    <Checkbox {...{
      ...row.getToggleRowSelectedProps(),
      onChange: e => {
        if (rowSelection === 'single') {
          toggleAllRowsSelected(false);
        }
        toggleRowSelected(row.id, e.target.checked);
        onRowSelected(row.original, e.target.checked);
      },
      radio: rowSelection === 'single'
    }}
    />
  )
});
